import { key } from "./slice";
import { AuthState } from "./types";
import { createSelector } from "@reduxjs/toolkit";

const selectSelf = (state: { [key]: AuthState }) => state[key];

export const selectCurrentUser = createSelector(selectSelf, (state) =>
  state.isAuthenticated ? state.user : undefined
);
